module.exports = __webpack_public_path__ + "img/電気回路_1_6_3.7d09e8e0.png";